import React from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { Stack } from '@mui/material'
import { Loader } from 'components'
import { useWorkOSAuth } from 'hooks'
import { type Route, ROUTES } from 'routes'
import { vhMinus } from 'utils/textZoom'

interface ProtectedRouteProps {
  redirectPath?: Route
}

export const ProtectedRoute = (props: ProtectedRouteProps) => {
  const { redirectPath = ROUTES.SIGN_IN } = props
  const { isAuthenticated, isLoading } = useWorkOSAuth()
  const location = useLocation()
  const isDevBypassEnabled =
    import.meta.env.MODE === 'development' &&
    new URLSearchParams(location.search).get('authBypass') === '1'

  if (isLoading) {
    return (
      <Stack justifyContent="center" alignItems="center" height={vhMinus()}>
        <Loader size={64} />
      </Stack>
    )
  }

  if (isDevBypassEnabled) {
    return <Outlet />
  }

  if (!isAuthenticated) {
    return <Navigate to={redirectPath} replace />
  }

  return <Outlet />
}
